import React from 'react';
import {
  Box, Divider, Typography,
} from '@mui/material';
import { alpha } from '@mui/material/styles';
import { GetnetMetadataDetails } from '../../types/authorization';
import { theme } from '../../theme';

type PatCardDetailsProps = {
  metadata: GetnetMetadataDetails;
  title?: string;
}

export default function PatCardDetails(props: PatCardDetailsProps) {
  const {
    metadata,
    title,
  } = props;

  const cardDetails = [
    ...(metadata.franchiseName ? [{
      id: 1,
      label: 'Tipo',
      value: metadata.franchiseName,
    }] : []),
    ...(metadata.issuerName ? [{
      id: 2,
      label: 'Emisor',
      value: metadata.issuerName,
    }] : []),
    ...(metadata.lastDigits ? [{
      id: 3,
      label: 'Número',
      value: `**** **** **** ${metadata.lastDigits}`,
    }] : []),
    ...(metadata.validUntil ? [{
      id: 4,
      label: 'Válida hasta',
      value: `${metadata.validUntil.split('-')[1]}/${metadata.validUntil.split('-')[0]}`,
    }] : []),
  ];

  if (cardDetails.length === 0) {
    return null;
  }

  return (
    <Box
      width="100%"
      sx={{
        borderRadius: 5, padding: 5, backgroundColor: alpha(theme.palette.background.defaultSecondary, 0.5), border: `1px solid ${theme.palette.secondary.main}`,
      }}
    >
      {title && (
        <Typography variant="body1" align="center" fontWeight="bold" marginTop={2} marginBottom={5}>
          {title}
        </Typography>
      )}
      <Box sx={{ width: { md: '100%' }, placeSelf: { xs: 'normal', md: 'center' } }}>
        {cardDetails.map((details, index) => (
          <div key={details.id}>
            <div
              style={{
                display: 'flex', placeContent: 'space-between', alignItems: 'center', height: '30px',
              }}
            >
              <Typography textAlign="left" variant="body2" width={{ xs: '45%', sm: '50%' }}>
                {details.label}
              </Typography>
              <Typography width="100%" textAlign="right" color="textSecondary">
                {details.value}
              </Typography>
            </div>
            {index !== cardDetails.length - 1 && (
              <Divider style={{ marginBlock: '5px' }} />
            )}
          </div>
        ))}
      </Box>
    </Box>
  );
}

PatCardDetails.defaultProps = {
  title: undefined,
};
